import { render, staticRenderFns } from "./ModalFormRuleComponent.vue?vue&type=template&id=42b9e34c&scoped=true"
import script from "./ModalFormRuleComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormRuleComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalFormRuleComponent.vue?vue&type=style&index=0&id=42b9e34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b9e34c",
  null
  
)

export default component.exports